import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { Hook } from './components/Hook';
import { Pain } from './components/Pain';
import { Method } from './components/Method';
import { Preview } from './components/Preview';
import { Skills } from './components/Skills';
import { ValueStack } from './components/ValueStack';
import { Pricing } from './components/Pricing';
import { Faq } from './components/Faq';
import { Guarantee } from './components/Guarantee';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen w-full bg-cream font-sans" data-id="element-0" data-mp="2wjqff1dkvuk0">
      <UrgencyBar data-id="element-1" data-mp="28ufpkexrnkkn" />
      <main data-id="element-2" data-mp="28tw62tsgwo4i">
        <Hero data-id="element-3" data-mp="28tme50nv46w6" />
        <Hook data-id="element-4" data-mp="28t4lsf4bmctj" />
        <Pain data-id="element-5" data-mp="28sl32w6ujkeg" />
        <Method data-id="element-6" data-mp="28sbad0uf2z52" />
        <Preview data-id="element-7" data-mp="23vci6nubd29i" />
        <Skills data-id="element-8" data-mp="23vuoyeelqyvo" />
        <ValueStack data-id="element-9" data-mp="23u9v6r043jyv" />
        <Pricing data-id="element-10" data-mp="23ut97wmn5o7m" />
        <Faq data-id="element-11" data-mp="23t8ea5wf0398" />
        <Guarantee data-id="element-12" data-mp="3ijxnsm94vshs" />
      </main>
      <Footer data-id="element-13" data-mp="3ikqwvtvkeu33" />
    </div>;
}